import C_NA from './NA';
import C_Other from './Other';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const NA_SITES: string[] = ['us', 'ca', 'za'];

    return <>{NA_SITES.includes(locale) ? <C_NA /> : <C_Other />}</>;
}
